import React, { useDeferredValue, useState } from 'react'
import { Link } from 'react-router-dom'
import PageHeader from '../../components/PageHeader'
import { Button, Collapse, OverlayTrigger, Tooltip } from 'react-bootstrap'
import CustomPagination from '../../components/CustomPagination'
import useLiveDataTable from '../../hooks/useLiveDataTable'
import {
  useGetCompletedJobQuery,
  useRemoveJobMutation,
  useStatusPaidMutation,
} from '../../redux/services/JobService'
import { deleteConfirmation, loadingConfirmation } from '../../utils'
import CompletedJobFilter from './CompletedJobFilter'
import RateConModal from './components/RateConModal'
import PodReceiptModal from './components/PodReceiptModal'
import { Download } from 'react-bootstrap-icons'
import JSZip from 'jszip'
import { saveAs } from 'file-saver'
import { FILES_URL } from '../../redux/services/apiConstant'
const CompletedJobs = () => {
  const { currentPage, perPage, q, handlePageChange, handlePerPageChange, searchBy } =
    useLiveDataTable()

  const [isShow, setIsShow] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [isView, setIsView] = useState(false)
  const [open, setOpen] = useState(false)
  const [query, setQuery] = useState(null)
  const params = useDeferredValue(query)

  const [removeRequest] = useRemoveJobMutation()
  const [statusRequest] = useStatusPaidMutation()

  const {
    data: data2,
    isFetching,
    refetch,
  } = useGetCompletedJobQuery({
    id: '',
    pagination: `?page=${currentPage}&per_page=${perPage}&search_by=${searchBy}&search=${q}${
      params?.id ? '&amount_status=' + params?.id : ''
    }`,
  })
  const completedJobs = data2?.response?.data?.data
  const total = data2?.response?.data?.total
  // Modal state
  const [showRateCon, setShowRateCon] = useState(false)
  const [rateConUrl, setRateConUrl] = useState(null)

  const [showPod, setShowPod] = useState(false)
  const [podUrl, setPodUrl] = useState(null)
  const downloadAllFiles = async files => {
    const zip = new JSZip()

    await Promise.all(
      files.map(async (fileUrl, index) => {
        try {
          const response = await fetch(fileUrl)
          if (!response.ok) throw new Error('File not found')

          const blob = await response.blob()
          zip.file(`file_${index + 1}${fileUrl.slice(fileUrl.lastIndexOf('.'))}`, blob)
        } catch (error) {
          console.error('❌ Error fetching file:', error)
        }
      })
    )

    const content = await zip.generateAsync({ type: 'blob' })
    saveAs(content, 'RateCon_Docs.zip')
  }
  return (
    <>
      <PageHeader name='Trips' />
      <div className='main-container container-fluid'>
        {' '}
        {/* Start::row-1 */}
        <div className='row'>
          <div className='col-xl-12'>
            <div className='card custom-card'>
              <div className='card-header w-100'>
                <div className='row w-100 m-0 justify-content-between'>
                  <div className='col-auto p-0 ms-1'>
                    <Button
                      className='btn btn-primary  '
                      onClick={() => setOpen(!open)}
                      aria-controls='collapse-inputs'
                      aria-expanded={open}
                    >
                      <i className='ri-filter-2-fill' />
                    </Button>
                  </div>
                  <div className='col-lg-3 col-5 p-0'>
                    <div className='input-group m-0'>
                      <span
                        className='input-group-text bg-transparent border text-primary'
                        id='basic-addon1'
                      >
                        <i className='ri-search-line' />
                      </span>
                      <input
                        className='form-control'
                        type='text'
                        placeholder='Search Here...'
                        aria-describedby='basic-addon1'
                      />
                    </div>
                  </div>
                </div>
              </div>
              <Collapse in={open}>
                <div className='w-100'>
                  <CompletedJobFilter setQuery={setQuery} />
                </div>
              </Collapse>
              <div className='card-body'>
                <CustomPagination
                  isFetching={isFetching}
                  data={completedJobs}
                  total={total}
                  onChangePage={handlePageChange}
                  onChangeRowsPerPage={handlePerPageChange}
                  paginationDefaultPage={currentPage}
                  columns={[
                    { name: 'Driver', selector: row => row?.driver?.full_name, sortable: true },
                    { name: 'Pickup Address', selector: row => row.pickup_address, sortable: true },
                    { name: 'Drop-off Address', selector: row => row.drop_address, sortable: true },
                    // { name: 'Selected Date & Time', selector: row => row.selectedDateTime, sortable: true },
                    {
                      name: 'Rate Con',
                      cell: row =>
                        row?.rate_confirmation_document_url ? (
                          <Button
                            variant='link'
                            size='sm'
                            onClick={() => {
                              setRateConUrl(row.rate_confirmation_document_url)
                              setShowRateCon(true)
                            }}
                          >
                            View
                          </Button>
                        ) : (
                          <div className='badge bg-danger'>No Rate Doc</div>
                        ),
                    },
                    {
                      name: 'POD/Receipts',
                      cell: row =>
                        row?.job_trip_documents?.filter(i => i.type === 'DROPOFF')?.length > 0 ? (
                          <Button
                            variant='link'
                            size='sm'
                            onClick={() => {
                              setPodUrl(row.job_trip_documents.filter(i => i.type === 'DROPOFF'))
                              setShowPod(true)
                            }}
                          >
                            View
                          </Button>
                        ) : (
                          <div className='badge bg-danger'>No POD/Receipt</div>
                        ),
                    },

                    { name: 'Job Amount', selector: row => `$${row.job_amount}`, sortable: true },
                    // { name: 'Broker', selector: row => row.broker?.broker_name, sortable: true },
                    {
                      name: 'Amount Status',
                      selector: row =>
                        row.amount_status == 'PAID' ? (
                          <button
                            className='badge bg-success border-0 border-0 px-3 py-1 s-15'
                            disabled={true}
                          >
                            {row.amount_status}
                          </button>
                        ) : (
                          <button
                            onClick={() =>
                              loadingConfirmation(() => statusRequest(row?.id), 'Update Status')
                            }
                            className='badge bg-danger border-0 px-3 py-1 s-15'
                          >
                            {row.amount_status}
                          </button>
                        ),
                      sortable: false,
                    },
                    {
                      name: 'Factoring Company',
                      selector: row => row.factory_company?.company_name,
                      sortable: true,
                    },
                    {
                      name: 'Show  Document',
                      selector: row => (row?.show_original_document ? 'Yes' : 'No'),
                      sortable: true,
                    },
                    {
                      name: 'Show Rate Con',
                      selector: row => (row?.show_rate_to_driver ? 'Yes' : 'No'),
                      sortable: true,
                    },
                    {
                      name: 'Status',
                      selector: row => <span className='badge bg-success'>{row.status}</span>,
                      sortable: false,
                    }, // Assigned, Pending, Active, Completed,
                    { name: 'Created At', selector: row => row?.created_at, sortable: true },
                    {
                      name: 'Actions',
                      cell: row => (
                        <div className='hstack gap-1 fs-1'>
                          <Link
                            aria-label='view'
                            to={`/job-view/${row?.id}`}
                            className='btn btn-icon btn-sm btn-primary-light btn-wave waves-effect waves-light'
                          >
                            <i className='ri-eye-fill' />
                          </Link>
                          <Link
                            aria-label='view'
                            to={`/invoice/${row?.id}`}
                            target='_blank'
                            title='Trip Details'
                            className='btn btn-icon btn-sm btn-success-light btn-wave waves-effect waves-light'
                          >
                            <i className='ri-file-fill' />
                          </Link>
                          <a
                            aria-label='delete'
                            onClick={() => deleteConfirmation(() => removeRequest(row?.id))}
                            className='btn btn-icon btn-sm btn-danger-light btn-wave waves-effect waves-light'
                          >
                            <i className='ri-delete-bin-7-line' />
                          </a>
                          <a
                            aria-label='delete'
                            onClick={() => deleteConfirmation(() => removeRequest(row?.id))}
                            className='btn btn-icon btn-sm btn-danger-light btn-wave waves-effect waves-light'
                          >
                            <i className='ri-mail-line' />
                          </a>
                          <OverlayTrigger
                            placement='top'
                            overlay={
                              <Tooltip id='download-tooltip'>Download Rate Con & Docs</Tooltip>
                            }
                          >
                            <span
                              onClick={() => {
                                const urls = []

                                if (row?.rate_confirmation_document) {
                                  urls.push(FILES_URL + row.rate_confirmation_document)
                                }

                                row?.job_trip_documents
                                  ?.filter(item => item.type === 'DROPOFF')
                                  .forEach(doc => {
                                    urls.push(FILES_URL + doc.submitted_attachment)
                                  })

                                downloadAllFiles(urls)
                              }}
                              style={{ cursor: 'pointer' }}
                              className='btn btn-icon btn-sm btn-danger-light btn-wave waves-effect waves-light span_job'
                            >
                              <Download size={24} className='job_hover_' />
                            </span>
                          </OverlayTrigger>
                        </div>
                      ),
                      ignoreRowClick: true,
                      width: '180px',
                    },
                  ]}
                />
              </div>
            </div>
            {/*<AddCompanyModal
                            show={isShow}
                            handleClose={() => setIsShow(false)}
                        />
                        <EditCompanyModal
                            show={isEdit}
                            handleClose={() => setIsEdit(false)}
                        />*/}
          </div>

          {/* Modals */}
          <RateConModal
            show={showRateCon}
            handleClose={() => setShowRateCon(false)}
            documentUrl={rateConUrl}
          />

          <PodReceiptModal
            show={showPod}
            handleClose={() => setShowPod(false)}
            documents={podUrl}
          />
        </div>
      </div>
    </>
  )
}

export default CompletedJobs
